import { useEffect } from 'react';

/**
 * Adds noindex/nofollow to the robots meta tag for the current route.
 * Restores the previous value on unmount so parent-level settings are respected.
 */
export default function NoIndexMeta() {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]');
    const prev = meta ? meta.content : null;

    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'robots';
      document.head.appendChild(meta);
    }
    meta.content = 'noindex, nofollow';

    return () => {
      if (prev !== null) {
        meta.content = prev;
      } else {
        meta.parentNode && meta.parentNode.removeChild(meta);
      }
    };
  }, []);

  return null;
}
